import angular from 'angular';
import paginationBarComponent from './paginationBar.component';

let paginationBarModule = angular.module('paginationBar', []).directive('paginationBar', paginationBarComponent);

export default paginationBarModule;



// WEBPACK FOOTER //
// ./app/components/paginationBar/paginationBar.js